/**
 * «А сколько это в долларах?»
 *
 * Панель, которая открывается нажатием на цену. Показывает ту же сумму в
 * ходовых валютах и честно говорит, на какое число взят курс: пересчёт —
 * справка для головы, а не новая цена камня. Записанной ценой остаётся та,
 * которую назвал поставщик.
 */
import { useEffect, useState } from 'react';
import { parseMoney, formatMoney } from '@core';
import { loadRates, convert, ratesAsOf, HANDY_CURRENCIES, type Rates } from '../lib/rates';

export function MoneySheet({ value, currency, caption, onClose }: {
  value: number;
  currency: string;
  /** Что именно за сумма: «за карат», «за всё» — чтобы не гадать. */
  caption?: string;
  onClose: () => void;
}) {
  const [rates, setRates] = useState<Rates | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void loadRates().then((r) => { setRates(r); setLoading(false); });
  }, []);

  const others = [currency, ...HANDY_CURRENCIES.filter((c) => c !== currency)];
  const shown = others
    .map((c) => ({ code: c, sum: c === currency ? value : convert(value, currency, c, rates) }))
    .filter((x) => x.sum != null);

  return (
    <>
      <div className="backdrop" onClick={onClose} />
      <div className="sheet">
        <div className="grip" />
        <h2 className="t">{formatMoney(parseMoney(Math.round(value), currency)!)}</h2>
        <p className="lead">
          {caption ? `${caption} · ` : ''}названо в {currency}
        </p>

        {loading && <div className="skeleton" style={{ height: 54, marginBottom: 10 }} />}

        {!loading && !rates && (
          <div className="memo warn">
            Курсов нет: они не успели загрузиться ни разу, а сейчас нет связи.
            Появится сеть — пересчёт заработает и дальше будет работать без неё.
          </div>
        )}

        {shown.length > 1 && (
          <div className="fxlist">
            {shown.map((x) => (
              <div className={`fxrow${x.code === currency ? ' own' : ''}`} key={x.code}>
                <span className="c">{x.code}</span>
                <b>{formatMoney(parseMoney(Math.round(x.sum!), x.code)!)}</b>
                {x.code === currency && <i>как назвали</i>}
              </div>
            ))}
          </div>
        )}

        {rates && (
          <p className="meta" style={{ marginTop: 12 }}>
            Пересчёт справочный, по курсу на {ratesAsOf(rates)}
            {rates.stale ? ' (свежее получить не удалось)' : ''}. В каталоге
            хранится та цена, которую назвал поставщик.
          </p>
        )}

        <div className="dock" style={{ position: 'static', padding: '12px 0 0' }}>
          <button className="btn btn-secondary" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </>
  );
}
